/**
 * Acqs generated-PDF download — generate on the server, then download.
 *
 * Mounts on `form[data-bank-pdf-download]` (the Scope of Work bank PDF,
 * `templates/acqs/_sow_bank_pdf_card.html`) and `form[data-pdf-download]` (the
 * purchase contract, `templates/acqs/_offer_contract_card.html`, and the
 * assignment, `templates/acqs/_assignment_generate_form.html` in the Steps card and the
 * Assignment PDFs card), plus `button[data-pdf-download-as-is]` (the Create Offer
 * sheet's Generate as-is, which posts its form's fields to the button's URL). Attachment
 * responses do not navigate away, so the form is handled with fetch instead of
 * a normal submit, restoring its spinner after either the download or an error
 * response.
 *
 * Optional attributes on the form:
 *   data-pdf-download-success — the success toast text
 *   data-pdf-download-refresh — URL to GET after the download; the response
 *                               replaces the element named by
 *                               data-pdf-download-target (outerHTML)
 *   data-pdf-download-event   — JSON `offerChanged` detail fired on body after the
 *                               download, so the offer's Steps cards and other
 *                               listeners refresh too
 */

import { fetchDownload } from './file-download.js';

(function () {

    function showBankPdfDownloadSuccess(form) {
        if (window.SeeMe && window.SeeMe.toast) {
            window.SeeMe.toast.success(
                form.getAttribute('data-pdf-download-success') || 'Bank PDF generated and attached to the lead.'
            );
        }
    }

    function refreshAfterDownload(form) {
        var url = form.getAttribute('data-pdf-download-refresh');
        var target = form.getAttribute('data-pdf-download-target');
        var detail = form.getAttribute('data-pdf-download-event');
        if (url && target && window.htmx) {
            window.htmx.ajax('GET', url, {target: target, swap: 'outerHTML'});
        }
        if (detail) {
            document.body.dispatchEvent(new CustomEvent('offerChanged', {detail: JSON.parse(detail)}));
        }
    }

    /**
     * POST `form`'s fields to `action` and download the PDF it answers with, through the
     * shared `fetchDownload` (spinner, in-flight guard keyed by `action`, error toast).
     * `afterDownload` runs only on success (toast, refresh).
     */
    function downloadPdf(action, form, submitBtn, afterDownload) {
        var errorMessage = 'Could not generate the PDF. Please try again.';
        var init;
        try {
            // FormData and the csrf read run before fetchDownload marks anything in flight, so
            // a throw here leaves no button stranded.
            var csrfToken = window._cc && window._cc.getCsrfToken ? window._cc.getCsrfToken() : '';
            var headers = csrfToken ? {'X-CSRFToken': csrfToken} : {};
            // Plain fetch skips htmx:configRequest, so pass the tab id by hand or
            // this tab would see its own stale banner (acqs-ws.js).
            if (window.acqsTabId) headers['X-Acqs-Tab-Id'] = window.acqsTabId;
            init = {method: form.method || 'POST', headers: headers, body: new FormData(form)};
        } catch (err) {
            if (window.SeeMe && window.SeeMe.toast) window.SeeMe.toast.error(errorMessage);
            return;
        }
        fetchDownload(action, {
            init: init, button: submitBtn, fallbackName: 'scope-of-work.pdf',
            expectType: 'application/pdf', errorMessage: errorMessage,
        }).then(function (saved) {
            if (saved) afterDownload();
        }).catch(function () {
            // The PDF saved; only the success toast or the refresh after it failed.
            if (window.SeeMe && window.SeeMe.toast) window.SeeMe.toast.error('The PDF downloaded, but the page could not refresh.  Reload it.');
        });
    }

    document.body.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form[data-bank-pdf-download], form[data-pdf-download]')) return;
        e.preventDefault();
        downloadPdf(form.action, form, e.submitter || form.querySelector('button[type="submit"]'), function () {
            showBankPdfDownloadSuccess(form);
            refreshAfterDownload(form);
        });
    });

    /**
     * Labels of the fields in the trigger's `data-pdf-download-as-is-fields` that
     * are empty. A field whose form group is hidden is skipped.
     */
    function emptyAsIsFields(trigger) {
        var form = trigger.form;
        var data = new FormData(form);
        var fields = JSON.parse(trigger.getAttribute('data-pdf-download-as-is-fields') || '[]');
        return fields.filter(function (field) {
            var input = form.elements[field[0]];
            if (input && !input.closest) input = input[0];  // a radio group
            var group = input && (input.closest('.form-group') || input);
            if (group && !group.getClientRects().length) return false;
            return !String(data.get(field[0]) || '').trim();
        }).map(function (field) { return field[1]; });
    }

    // The Create Offer sheet's Generate as-is (`_offer_create_sheet.html`). Plain
    // buttons, not submits: the sheet's form is htmx-posted, and a submit would
    // create the Offer. They send that form's fields to the trigger's URL instead.
    // This runs on body, before the dropdown's own document listener: with nothing
    // empty it downloads and drops `data-dropdown` until the click has finished, so
    // the menu stays shut while document listeners (closing other open menus) still
    // run; otherwise it fills the menu's list and lets the menu open, and Generate
    // anyway downloads from there.
    document.body.addEventListener('click', function (e) {
        var trigger = e.target.closest && e.target.closest('button[data-pdf-download-as-is]');
        if (!trigger || !trigger.form) return;
        var empty = emptyAsIsFields(trigger);
        if (!empty.length) {
            trigger.removeAttribute('data-dropdown');
            window.setTimeout(function () { trigger.setAttribute('data-dropdown', ''); });
            downloadPdf(trigger.getAttribute('data-pdf-download-as-is'), trigger.form, trigger, function () {});
            return;
        }
        var list = trigger.closest('.dropdown').querySelector('[data-pdf-download-as-is-missing]');
        if (!list) return;
        list.textContent = '';
        empty.forEach(function (label) {
            var item = document.createElement('li');
            item.textContent = label;
            list.appendChild(item);
        });
    });

    document.body.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('button[data-pdf-download-as-is-confirm]');
        if (!btn || !btn.form) return;
        var trigger = document.querySelector('button[data-pdf-download-as-is][form="' + btn.form.id + '"]');
        if (!trigger) return;
        downloadPdf(trigger.getAttribute('data-pdf-download-as-is'), btn.form, trigger, function () {});
    });

})();
